module.exports = __webpack_public_path__ + "img/55.04e305c0.jpg";